export type BookingOrigin = "legacy" | "professional" | "ai_native" | "reception" | "admin" | "online";

export const bookingOriginPresentation: Record<BookingOrigin, { label: string; compact: string; tone: string }> = {
  professional: { label: "Profissional", compact: "PRO", tone: "bg-violet-100 text-violet-800 border-violet-200" },
  ai_native: { label: "IA nativa", compact: "IA", tone: "bg-sky-100 text-sky-800 border-sky-200" },
  reception: { label: "Recepção", compact: "REC", tone: "bg-amber-100 text-amber-800 border-amber-200" },
  admin: { label: "Administrador", compact: "ADM", tone: "bg-rose-100 text-rose-800 border-rose-200" },
  online: { label: "Online", compact: "WEB", tone: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  legacy: { label: "Registro anterior", compact: "ANT", tone: "bg-slate-100 text-slate-700 border-slate-200" },
};

export function resolveBookingOrigin(appointment: { bookingOrigin?: string | null; isWalkIn?: boolean | null }): BookingOrigin {
  const origin = appointment.bookingOrigin as BookingOrigin | undefined;
  if (origin && origin in bookingOriginPresentation) return origin;
  if (appointment.isWalkIn) return "reception";
  return "legacy";
}

export function resolveStaffBookingOrigin(staffRole: string | null | undefined): BookingOrigin {
  if (staffRole === "funcionario") return "professional";
  if (staffRole === "recepcionista" || staffRole === "caixa") return "reception";
  return "admin";
}

export function bookingOriginHoverLabel(origin: BookingOrigin, creatorName?: string | null): string {
  const originLabel = bookingOriginPresentation[origin].label;
  return creatorName
    ? `Origem: ${originLabel} · Criado por: ${creatorName}`
    : `Origem: ${originLabel} · Criador não identificado`;
}
